import React from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import logo from "../images/logo1.jpg";
import { FaInstagram, FaFacebookF, FaTwitter,FaGlobe } from "react-icons/fa";

const Header = () => {
  
  return (
    <>
      <header className="header">

        <div className="top-bar">
          <div className="top-left">
            <span>☎ ८७६६५६९१०१ / ७५८८५७७२०९</span>
            <span>✉ rrburandegranthalay@gmail.com</span>
          </div>

          <div className="top-right">
            <a
              href="https://www.instagram.com/rrburandegranthalay?igsh=NTQ0OTI5dGtlY2c4&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="social-icon" />
            </a>
            <FaFacebookF className="social-icon" />
            <FaTwitter className="social-icon" />
            
  
          </div>
          
        </div>

        <div className="main-header">
          <img src={logo} alt="Granthalay Logo" className="logo" />

          <div className="title-section">
            <div className="tagline">॥ तमसो मा ज्योतिर्गमय ॥</div>

            <div className="govt-text">
              शासन मान्य वर्ग - ड
            </div>

            <h1 className="main-title">
              कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय, कोडोली, ता. पन्हाळा, जि. कोल्हापूर
            </h1>

            <div className="award">
              महाराष्ट्र शासन – डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार प्राप्त
            </div>
          </div>
        </div>

        <nav className="navbar">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">आमच्याविषयी (About Us)</Link></li>
            <li><Link to="/events">उपक्रम व कार्यक्रम (Events)</Link></li>
            <li><Link to="/gallery">चित्रकृती (Gallery)</Link></li>
            <li><Link to="/publications">प्रकाशने (Publications)</Link></li>
            <li><Link to="/vision-mission">ध्येय व उद्दिष्टे (Vision & Mission)</Link></li>
            <li><Link to="/contact">संपर्क (Contact)</Link></li>
            <li><Link to="/donation">देणगी (Donation)</Link></li>
          </ul>
        </nav>

      </header>
    </>
  );
};

export default Header;